import Crane from '@cas/assets/images/object-types/crane.svg';
import Dozer from '@cas/assets/images/object-types/dozer.svg';
import DragLine from '@cas/assets/images/object-types/drag-line.svg';
import Drill from '@cas/assets/images/object-types/drill.svg';
import Grader from '@cas/assets/images/object-types/grader.svg';
import LargeLoader from '@cas/assets/images/object-types/large-loader.svg';
import LightVehicle from '@cas/assets/images/object-types/light-vehicle.svg';
import MaintenanceVehicle from '@cas/assets/images/object-types/maintenance-vehicle.svg';
import MediumVehicle from '@cas/assets/images/object-types/medium-vehicle.svg';
import OtherHeading from '@cas/assets/images/object-types/other-heading.svg';
import PersonnelTagTestStation from '@cas/assets/images/object-types/personnel-tag-test-station.svg';
import PersonnelTag from '@cas/assets/images/object-types/personnel-tag.svg';
import Scraper from '@cas/assets/images/object-types/scraper.svg';
import SelfTest from '@cas/assets/images/object-types/self-test.svg';
import ServiceTruck from '@cas/assets/images/object-types/service-truck.svg';
import ShovelWithHeading from '@cas/assets/images/object-types/shovel-with-heading.svg';
import Shovel from '@cas/assets/images/object-types/shovel.svg';
import SmallHeavy from '@cas/assets/images/object-types/small-heavy.svg';
import SmallWheelLoader from '@cas/assets/images/object-types/small-wheel-loader.svg';
import Stationary from '@cas/assets/images/object-types/stationary.svg';
import StemmingTruck from '@cas/assets/images/object-types/stemming-truck.svg';
import TestStation from '@cas/assets/images/object-types/test-station.svg';
import Truck from '@cas/assets/images/object-types/truck.svg';
import WaterCart from '@cas/assets/images/object-types/water-cart.svg';
import WheelDozer from '@cas/assets/images/object-types/wheel-dozer.svg';

// we export as this so that we can dynamically change the svg colour
const Unknown = `<svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M35.5508 24.0856C35.8378 23.961 36.1636 23.961 36.4506 24.0856L47.329 28.8073C47.7419 28.9865 48.009 29.3937 48.009 29.8438V42.4349C48.009 42.8939 47.7313 43.3074 47.3064 43.481L36.428 47.9249C36.1541 48.0368 35.8472 48.0368 35.5733 47.9249L24.6949 43.481C24.2699 43.3074 23.9922 42.8939 23.9922 42.4349V29.8438C23.9922 29.3937 24.2594 28.9865 24.6723 28.8073L35.5508 24.0856ZM26.2522 31.5394L34.8706 35.1334V45.1965L26.2522 41.6759V31.5394ZM37.1306 45.1965L45.749 41.6759V31.5394L37.1306 35.1334V45.1965ZM36.0006 33.156L43.993 29.823L36.0007 26.354L28.0082 29.823L36.0006 33.156Z"/>
</svg>
`;

// Fixme: The files should be exported in a type-safe map to verify that each ObjectType has an associated SVG.
export {
  Crane,
  Dozer,
  DragLine,
  Drill,
  Grader,
  LargeLoader,
  LightVehicle,
  MaintenanceVehicle,
  MediumVehicle,
  OtherHeading,
  PersonnelTagTestStation,
  PersonnelTag,
  Scraper,
  SelfTest,
  ServiceTruck,
  Shovel,
  ShovelWithHeading,
  SmallHeavy,
  SmallWheelLoader,
  Stationary,
  StemmingTruck,
  TestStation,
  Truck,
  Unknown,
  WaterCart,
  WheelDozer,
};
